module.exports = __webpack_public_path__ + "img/HZ-S4027.6cca3017.jpg";